import { useFlags, useLDClientError } from 'launchdarkly-react-client-sdk';
import { FeatureFlagsClient } from 'src/lib/constants';

// ai-v2 gates assistant-ui home/chat (AGR-117) and the managed-agents engine (AGR-49);
// their call sites ship in separate stacks. The 5.5 models (AGR-115) and learning-loop /
// Typesense-only cutover (AGR-116) are intentionally unflagged.
export function useAiV2Enabled(): boolean {
  const flags = useFlags();
  const error = useLDClientError();
  const isE2E = process.env.AGRIFUL_ENV === 'e2e' || process.env.E2E_MODE === 'true';
  return !isE2E && !error && flags[FeatureFlagsClient.AiV2] === true;
}
